import { TextLink } from '@assembly-js/design-system';
import { I18n } from 'aws-amplify';
import React from 'react';

import history from 'src/history';

type Only<T, U> = {
  [P in keyof T]: T[P];
} & {
  [P in keyof U]?: never;
};
type Either<T, U> = Only<T, U> | Only<U, T>;
interface AuthLinkActionButton {
  onClick: () => void;
}
interface AuthLinkActionWithHref {
  href: string;
}

// auth link button should have href or onClick prop provided.
type Props = Either<AuthLinkActionWithHref, AuthLinkActionButton> & {
  className?: string;
} & (
    | {
        children?: never;
        linkText: string;
      }
    | {
        children: React.ReactNode;
        linkText?: never;
      }
  );

export const AuthLinkActionButton: React.FC<Props> = ({
  className,
  onClick,
  children,
  linkText,
  href,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (href) {
      history.push(href);
    }
    onClick?.();
  };
  return (
    <div
      className={className}
      style={{
        justifyContent: 'center',
      }}
    >
      <TextLink
        className="text-gray-small text-[13px]"
        onClick={handleClick}
        variant="minimal"
        onMouseDown={(e) => e.preventDefault()}
      >
        {children ?? I18n.get(linkText)}
      </TextLink>
    </div>
  );
};
